import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { number } from 'echarts';

@Directive({
  selector: '[appCursor]'
})
export class CursorDirective {

  constructor(private el: ElementRef<HTMLInputElement>, private els: ElementRef<NgSelectComponent>) { }
  @HostListener('keydown', ['$event'])
  OnArrowUp(event: any) {
    debugger
    if (event.key == 'ArrowUp' || event.keyCode == 38) {
      event.preventDefault()
      return
    } else if (event.key == 'Enter' || event.keyCode == 13) {
      // Delay the cursor position adjustment to let the default action happen first
      //setTimeout(() => this.moveCursorToEnd(), 0);
      console.log(event)
      console.log(event.target?.value)
      this.moveCursorToEnd(event);
    }
    const invalidChars = ['^', '~', '|', '_', '\\', '`'];

    // Block invalid characters immediately
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
      return;
    }
  }


  //@HostListener('paste', ['$event'])
  //onPaste(event: ClipboardEvent) {
  // // const invalidPattern = /[\^~|_\\]/g; // regex for disallowed chars
  //  const invalidPattern = /[~|_\\`^]/g;
  //  const pastedText = event.clipboardData?.getData('text') ?? '';

  //  if (invalidPattern.test(pastedText)) {
  //    event.preventDefault(); // block paste// Optionally sanitize and insert cleaned text
  //    const cleaned = pastedText.replace(invalidPattern, '');
  //    const target = event.target as HTMLInputElement;
  //    const start = target.selectionStart ?? 0;
  //    const end = target.selectionEnd ?? 0;

  //    target.value = target.value.substring(0, start) + cleaned + target.value.substring(end);
  //    target.setSelectionRange(start + cleaned.length, start + cleaned.length);
  //  }
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const invalidPattern = /[~|_\\`^]/g;
    const pastedText = event.clipboardData?.getData('text') ?? '';

    if (invalidPattern.test(pastedText)) {
      event.preventDefault();

      const cleaned = pastedText.replace(invalidPattern, '');
      const target = event.target as HTMLInputElement;

      const start = target.selectionStart ?? 0;
      const end = target.selectionEnd ?? 0;

      const newValue =
        target.value.substring(0, start) +
        cleaned +
        target.value.substring(end);

      target.value = newValue;

      // Notify Angular/forms about the change
      target.dispatchEvent(new Event('input', { bubbles: true }));

      const cursorPos = start + cleaned.length;
      target.setSelectionRange(cursorPos, cursorPos);
    }
  
  }


  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    debugger
    this.moveCursorToEnd(event);
    return
    // Access the input element inside ng-select
    // Delay the cursor position adjustment to let the default action happen first
    //setTimeout(() => this.moveCursorToEnd(), 0);
  }
  private moveCursorToEnd(event: any) {
    // Find the ng-select component
    const ngSelectElement = this.el.nativeElement;

    // Find the input element inside ng-select
    const inputElement = ngSelectElement.querySelector('.ng-input input') as HTMLInputElement;

    if (inputElement) {
      setTimeout(() => {
        debugger
        inputElement.focus(); // Ensure the input field is focused
        console.log(inputElement.value)
        const spans = ngSelectElement.querySelectorAll('.ng-value.ng-star-inserted .ng-value-label span') as unknown as HTMLElement;
        if (spans) {
          console.log(spans[0]?.innerText)
          //spans[0].innerText = ''; // Update the text
          inputElement.value = ''
          inputElement.placeholder = ''
          inputElement.value = spans[0].innerText.toString().trim()
          spans[0].innerText=''
          const length = inputElement.value.length;
          inputElement.setSelectionRange(length, length);
        }
      }, 0); // Delay to ensure the DOM is updated
    }
  }
}
